import React from "react";
import PropTypes from "prop-types";
import { MenuOrga } from "../menu/menu-orga";
import { useHistory } from "react-router-dom";

import { ViewPort, MenuContainer } from "@weezevent/nacre";
import Logo from "../../public/images/logo.svg?url";
import MenuSideBar from "../menu/menu-side-bar"; // eslint-disable-line import/no-named-as-default
import TopBarModules from "./topBarModules/topBarModules";
import { useAllUserCapacities } from "utils/rights";

export const ContextTemplate = React.createContext({
	capacities: []
});

export default function Template({ organization, event, children, hideMenu }) {
	const history = useHistory();
	const capacities = useAllUserCapacities(organization.id());

	return (
		<ContextTemplate.Provider value={{ capacities }}>
			<ViewPort
				logo={Logo}
				onClickLogo={
					organization
						? () => history.push(`/access/O${organization.id()}`)
						: null
				}
				topBarModules={<TopBarModules organization={organization} />}
				displayMenuButton={Boolean(organization)}
			>
				{hideMenu ? (
					children
				) : (
					<MenuContainer
						display={Boolean(organization)}
						optionalMenu={
							event ? (
								<MenuOrga
									organizationId={organization.id()}
									isLevelEvent={Boolean(event?.id)}
								/>
							) : null
						}
						menu={
							<MenuSideBar
								organization={organization}
								event={event}
							/>
						}
					>
						{children}
					</MenuContainer>
				)}
			</ViewPort>
		</ContextTemplate.Provider>
	);
}

Template.defaultProps = {
	event: null,
	organization: null,
	history: null,
	withLeftMenu: true,
	children: null,
	hideMenu: false
};

Template.propTypes = {
	organization: PropTypes.object,
	event: PropTypes.object,
	children: PropTypes.node,
	hideMenu: PropTypes.bool
};
